"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelMutatorNumber = void 0;
var tslib_1 = require("tslib");
var collection_field_1 = require("../collection.field");
var number_field_1 = require("./number.field");
/** Methods to modify a number field */
var ModelMutatorNumber = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorNumber, _super);
    function ModelMutatorNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Set the field provided by number */
    ModelMutatorNumber.prototype.manual = function (newValue) {
        if (newValue == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        var value;
        if (typeof newValue === 'string') {
            value = parseFloat(newValue);
        }
        else {
            value = newValue;
        }
        if (value == null || isNaN(value)) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_MANUAL,
            value: value
        });
    };
    /** Set the value provided by bearing */
    ModelMutatorNumber.prototype.bearing = function (captureId) {
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_BEARING,
            captureId: captureId
        });
    };
    /** Set the field value provided by backbearing */
    ModelMutatorNumber.prototype.backBearing = function (captureId) {
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_BACK_BEARING,
            captureId: captureId
        });
    };
    /**
     * Set the field value provided by sag
     *
     * @param start CaptureId of the starting point
     * @param end CaptureId of the ending point
     * @param points CaptureId of the mid points
     */
    ModelMutatorNumber.prototype.sag = function (start, end, points) {
        var pointIds = points.slice();
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_SAG,
            start: start,
            end: end,
            points: pointIds
        });
    };
    /** Clone another field */
    ModelMutatorNumber.prototype.copy = function (from) {
        if (from.value == null) {
            this.manual(null);
            return true;
        }
        if (from.isManual()) {
            this.manual(from.value);
            return true;
        }
        if (from.isSag()) {
            var stateValue = from.stateValue;
            this.sag(stateValue.start, stateValue.end, stateValue.points);
            return true;
        }
        if (from.isBearing()) {
            this.bearing(from.stateValue.captureId);
            return true;
        }
        if (from.isBackBearing()) {
            this.backBearing(from.stateValue.captureId);
            return true;
        }
        return false;
    };
    ModelMutatorNumber.prototype.reverse = function () {
        if (!this.field.hasValue()) {
            return;
        }
        if (this.field.isBearing()) {
            // TODO: IKE Field does not support 'bearing' provider so bearings are not flipped
            return;
        }
        if (this.field.isBackBearing()) {
            // TODO: IKE Field does not support 'bearing' provider so bearings are not flipped
            return;
        }
        if (this.field.isSag()) {
            var stateValue = this.field.stateValue;
            this.sag(stateValue.end, stateValue.start, stateValue.points.slice());
            return;
        }
        // Manual numbers are not flipped
    };
    return ModelMutatorNumber;
}(collection_field_1.ModelMutator));
exports.ModelMutatorNumber = ModelMutatorNumber;
//# sourceMappingURL=number.field.mutator.js.map